import {
  Project,
  ProjectsData,
} from '../components/community/sections/projects/projectsData';
import localProjectsData from '../components/community/sections/projects/projectsData.json';

import { GOOGLE_API_KEY } from './constants';

export const fetchProjectsData = async (
  fileId: string
): Promise<ProjectsData> => {
  if (!GOOGLE_API_KEY) {
    console.warn('🔑 Google API key not found, using local projects data');
    return localProjectsData as ProjectsData;
  }

  try {
    // Create AbortController for timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000); // 3 second timeout

    const response = await fetch(
      `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media&key=${GOOGLE_API_KEY}`,
      {
        signal: controller.signal,
      }
    );
    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`Failed to fetch projects data: ${response.statusText}`);
    }

    const data = await response.json();
    return data as ProjectsData;
  } catch (error) {
    console.error('Error fetching projects data from Drive:', error);
    return localProjectsData as ProjectsData;
  }
};
